import { create } from 'zustand';

export interface League {
  id: string;
  name: string;
  isTemplate: boolean;
  created: string;
  ownershipPercentage: number;
  price: number | null;
  owners: number;
  commissioners: string[];
}

export interface LeagueState {
  leagues: League[];
  isLoading: boolean;
  error: string | null;
  searchQuery: string;
  sortField: keyof League;
  sortOrder: 'asc' | 'desc';
  page: number;
  rowsPerPage: number;
  selectedLeague: League | null;
  setLeagues: (leagues: League[]) => void;
  setLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
  setSearchQuery: (query: string) => void;
  setSortField: (field: keyof League) => void;
  setSortOrder: (order: 'asc' | 'desc') => void;
  setPage: (page: number) => void;
  setRowsPerPage: (rowsPerPage: number) => void;
  setSelectedLeague: (league: League | null) => void;
}

export const useLeagueStore = create<LeagueState>((set) => ({
  leagues: [],
  isLoading: false,
  error: null,
  searchQuery: '',
  sortField: 'name',
  sortOrder: 'asc',
  page: 0,
  rowsPerPage: 10,
  selectedLeague: null,
  setLeagues: (leagues) => set({ leagues }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  setSearchQuery: (searchQuery) => set({ searchQuery, page: 0 }),
  setSortField: (sortField) => set({ sortField }),
  setSortOrder: (sortOrder) => set({ sortOrder }),
  setPage: (page) => set({ page }),
  setRowsPerPage: (rowsPerPage) => set({ rowsPerPage, page: 0 }),
  setSelectedLeague: (league) => set({ selectedLeague: league }),
})); 